import { logEvent } from '~/config/firebase.config';
import { PUBLIC_DEMO_CLIENTS } from '~/config/gameParamsMemory';

/**
 * Jeux dont l'enregistrement des scores = la fin de la partie (podium). Les autres en
 * enregistrent en cours de route (Bomber Kitten à chaque manche, jeux Unity à chaque
 * mort) : pas de `game_end` pour eux.
 */
export const GAME_END_GAMES: ReadonlySet<string> = new Set([
    'unquiz',
    'unblind-test',
    'petit-bac',
    'geoloc',
    'draw-guessr',
    'estim',
]);

/** Les scores d'un podium arrivent en rafale (un par joueur) : une seule fin par fenêtre. */
export const GAME_END_WINDOW_MS = 60_000;

const lastEndAt = new Map<string, number>();

/**
 * Fin de partie (GA4 `game_end`) : les jeux de salle enregistrent les scores du podium à
 * la fin (`saveHighscore`). Avec `tv_game_start` (ScreenApp), mesure le temps mort entre
 * la fin d'une partie et le jeu suivant (parcours du 20/10). Une partie arrêtée avant le
 * podium n'en envoie pas. Bars seulement : ni aéroports (mode auto), ni démos publiques.
 * Renvoie true si l'événement est parti.
 */
export function trackGameEnd(
    clientID: string | undefined,
    gameID: string | undefined,
    mode: string | undefined,
    now = Date.now(),
    send: typeof logEvent = logEvent
): boolean {
    if (!clientID || !gameID || mode === 'auto' || PUBLIC_DEMO_CLIENTS.has(clientID)) return false;
    if (!GAME_END_GAMES.has(gameID)) return false;
    const key = `${clientID}:${gameID}`;
    const last = lastEndAt.get(key);
    if (last !== undefined && now - last >= 0 && now - last < GAME_END_WINDOW_MS) return false;
    lastEndAt.set(key, now);
    send('game_end', clientID, { clientID, gameID });
    return true;
}
